goog.provide('el8.appshared.form.buttons');

el8.appshared.form.buttons = {

    addNonDraftDialogButtons: function(form, doSaveFn, dialog) {
        form.addSaveButton(function(_form) {
            doSaveFn(_form);
        }, true);
        form.addSaveAndAnotherButton(function(_form) {
            doSaveFn(_form, true);
        }, false);
        form.addDiscardButton(function() {
            dialog.hide();
        });
        form.renderButtonSet();
    }

};
